<div class="flex gap-1 flex-wrap">
  <button
    type="button"
    class="bm-btn bm-btn-sm"
    [class.bm-btn-primary]="state.targetUserFromOperation()"
    [disabled]="state.readOnly()"
    (click)="state.setTargetUserFromOperation(true)"
  >
    Vom Auftrag übernehmen
  </button>
  <button
    type="button"
    class="bm-btn bm-btn-sm"
    [class.bm-btn-primary]="!state.targetUserFromOperation()"
    [disabled]="state.readOnly()"
    (click)="state.setTargetUserFromOperation(false)"
  >
    Fester Techniker
  </button>
</div>

@if (state.targetUserFromOperation()) {
  <div class="pl-1 mt-2 flex flex-col gap-1">
    <div class="text-xs">
      <span class="opacity-70">Aktuell wäre das: </span>
      <span class="font-semibold">
        {{ state.operationTechnicianName() || "kein Techniker — der Lagerist wählt beim Versand" }}
      </span>
    </div>
    @if (state.operationTechnicianIsPlaceholder()) {
      <div class="bm-alert bm-alert-warning bm-alert-soft text-xs">
        <fa-icon [icon]="iconWarn" />
        <span>
          Der Auftragstechniker ist ein <strong>Platzhalter</strong>. Das Lager kann erst versenden, sobald am
          Auftrag ein echter Techniker steht.
        </span>
      </div>
    }
  </div>
} @else {
  <div class="grid gap-x-2 mt-2" [class.grid-cols-2]="state.targetUserId() !== null">
    <fieldset class="bm-fieldset">
      <label class="bm-fieldset-label">Techniker</label>
      <select
        class="bm-select w-full"
        [ngModel]="state.targetUserId()"
        [disabled]="state.readOnly()"
        (ngModelChange)="state.setTechnician($event)"
      >
        <option [ngValue]="null">-- Techniker auswählen --</option>
        @for (technician of state.technicians(); track technician.id) {
          <option [ngValue]="technician.id">{{ technician.name }}</option>
        }
      </select>
    </fieldset>

    @if (state.targetUserId() !== null) {
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Umbuchungslager</label>
        @if (state.loadingWarehouses()) {
          <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Lade Lager…</div>
        } @else if (state.warehouses().length === 0) {
          <div class="text-sm opacity-60 italic min-h-[2.25rem] flex items-center">Kein Lager verfügbar</div>
        } @else {
          <select
            class="bm-select w-full"
            [ngModel]="state.targetWarehouseId()"
            [disabled]="state.readOnly()"
            (ngModelChange)="state.targetWarehouseId.set($event)"
          >
            <option [ngValue]="null">-- Lager auswählen --</option>
            @for (warehouse of state.warehouses(); track warehouse.id) {
              <option [ngValue]="warehouse.id">{{ warehouse.label }}</option>
            }
          </select>
        }
      </fieldset>
    }
  </div>
}

@if (state.selectedType() === "pickpoint") {
  <fieldset class="bm-fieldset mt-3 border-t border-base-200 pt-2">
    <label class="bm-fieldset-label">
      Abholauftrag wird erzeugt für
      @if (state.pickupHint(); as hint) {
        <span class="opacity-60">({{ hint }})</span>
      }
    </label>
    <input
      class="bm-input w-full"
      type="datetime-local"
      [ngModel]="state.pickupDate()"
      [disabled]="state.readOnly()"
      (ngModelChange)="state.pickupDate.set($event || '')"
    />
    @if (state.pickupError(); as error) {
      <div class="bm-alert bm-alert-warning bm-alert-soft text-xs mt-1">{{ error }}</div>
    } @else {
      <span class="text-xs opacity-60 mt-1">
        Standard ist eine Stunde vor Einsatzbeginn. Der Termin ist zugleich der Bezugspunkt für den
        Versandzeitpunkt.
      </span>
    }
    @if (state.initialConfig()?.pickup_operation_id && state.initialConfig()?.pickup_ticket_id) {
      <div class="text-xs mt-1 flex flex-col gap-0.5">
        <a
          [routerLink]="['/ticket', state.initialConfig()?.pickup_ticket_id]"
          target="_blank"
          class="text-primary hover:underline w-fit"
        >
          Abholauftrag öffnen (Ticket #{{ state.initialConfig()?.pickup_ticket_id }}) ↗
        </a>
        <span class="opacity-60">
          Eine Änderung verschiebt auch den Abholauftrag und alle mit ihm verlinkten Versandziele.
        </span>
      </div>
    }
  </fieldset>
}
